export default {"src":"/_next/static/media/scale-black.dc8c46d4.svg","height":2893,"width":4953,"blurWidth":0,"blurHeight":0};